// extracted by mini-css-extract-plugin
export default {"base":"MiniButton_base__2GHw2","blue":"MiniButton_blue__kb9Ya","red":"MiniButton_red__WuCJP","gray":"MiniButton_gray__j-FKi","disabled":"MiniButton_disabled__u-Kwf"};